import { render, staticRenderFns } from "./pop-route.vue?vue&type=template&id=23fbfc7a&scoped=true&"
import script from "./pop-route.vue?vue&type=script&lang=js&"
export * from "./pop-route.vue?vue&type=script&lang=js&"
import style0 from "./pop-route.vue?vue&type=style&index=0&id=23fbfc7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbfc7a",
  null
  
)

export default component.exports